import {
    TopBetsTimeRangeActions,
    TopBetsTimeRangeSetFilterDataAction,
    TopBetsTimeRangeSetLoadingData,
    TopBetsTimeRangeTopic,
} from './time-range-nav.constants';
import { AppDispatch, AppThunk, GetState } from '@om-fe/core/core/types';
import {
    apiSubscribeAction,
    apiUnsubscribeAction,
    attachReducerAction,
    detachReducerAction,
} from '@om-fe/core/utils/action';
import {
    getTopBetsTimeRangeSliceName,
    getTopBetsTimeRangeTopic,
} from './time-range-nav.utils';
import { 
    TimeRangeListStateModel,
    timeRangeNavReducerCreator,
} from './time-range-nav.reducer';
import { filterNullParams } from '@om-fe/core/utils/router';
import getSlice from '@om-fe/core/utils/get-slice';

export const topBetsTimeRangeSetLoadingData = (slice: string, isLoadingData: boolean = false): TopBetsTimeRangeSetLoadingData => ({
    type: TopBetsTimeRangeActions.SetLoadingData,
    meta: {
        slice,
    },
    payload: {
        isLoadingData,
    },
});

export const topBetsTimeRangeSetFilterData = (
    slice: string,
    disciplineId: string,
    locationId?: string,
    categoryId?: string,
): TopBetsTimeRangeSetFilterDataAction => ({
    type: TopBetsTimeRangeActions.SetFilterData,
    meta: {
        slice,
    },
    payload: {
        disciplineId,
        locationId,
        categoryId,
    },
});

export const getTopBetsTimeRange = (
    instanceId: string,
    disciplineId: string,
    locationId?: string,
    categoryId?: string,
) => (dispatch: AppDispatch) => {
    const slice: string = getTopBetsTimeRangeSliceName(instanceId);
    const topic: TopBetsTimeRangeTopic = getTopBetsTimeRangeTopic(
        disciplineId,
        locationId,
        categoryId,
    ) as TopBetsTimeRangeTopic;
    
    dispatch(attachReducerAction(slice, timeRangeNavReducerCreator(instanceId)));
    dispatch(topBetsTimeRangeSetFilterData(
        slice,
        disciplineId,
        locationId,
        categoryId,
    ));
    dispatch(apiSubscribeAction(topic.path, filterNullParams(topic.params), slice));
};

export const removeTopBetsTimeRange = (
    instanceId: string,
): AppThunk => (dispatch: AppDispatch, getState: GetState) => {
    const slice: string = getTopBetsTimeRangeSliceName(instanceId);
    const locationState: TimeRangeListStateModel | undefined = getSlice<TimeRangeListStateModel>(getState(), slice);

    if (!locationState) {
        return;
    }

    const topic: TopBetsTimeRangeTopic = getTopBetsTimeRangeTopic(
        locationState.disciplineId!,
        locationState.locationId,
        locationState.categoryId,
    ) as TopBetsTimeRangeTopic;

    dispatch(detachReducerAction(slice));
    dispatch(apiUnsubscribeAction(topic.path, filterNullParams(topic.params), slice));
};
